import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";

import { hasFeatureFlags } from "../../../api/user-feature-flags";
import { Button } from "../../../components/ui-kit/button";
import { Dialog } from "../../../components/ui-kit/dialog";
import { UserFeatureFlags } from "../../../components/user-feature-flags";
import { Users, UsersItem } from "./users";

/**
 * Feature flags of any user, patient or staff. Its own dialog rather than a
 * section of the edit dialog: each toggle saves on its own, per
 * `Users.updateFeatureFlag`, which would sit badly next to that dialog's
 * Save/Cancel - Cancel could not take a flipped flag back.
 */
export const UserFlagsDialog = observer(function UserFlagsDialog(props: {
  item: UsersItem;
  users: Users;
  onClose: () => void;
}) {
  return (
    <Dialog open onOpenChange={(open) => !open && props.onClose()}>
      <h3 className="mb-6 text-base font-bold">
        <Trans>Feature flags: {props.item.username}</Trans>
      </h3>

      {hasFeatureFlags(props.item.feature_flags) ? (
        <UserFeatureFlags
          api={props.users.api}
          flags={props.item.feature_flags ?? {}}
          onSave={(flag, update) =>
            props.users.updateFeatureFlag(props.item.uuid, flag, update)
          }
        />
      ) : (
        // an API that predates the flags registry
        <p className="text-muted-foreground">
          <Trans>This user has no feature flags.</Trans>
        </p>
      )}

      <div className="mt-6 flex justify-center">
        <Button onClick={props.onClose}>
          <Trans>Close</Trans>
        </Button>
      </div>
    </Dialog>
  );
});
